import { tsValidateUniqueId } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
import { EhrInstanceKbVersion_CollectionName } from './consts.js';
const Validator_ModifiableProps = {
    ehrInstanceId: tsValidateUniqueId,
    versionId: tsValidateUniqueId,
};
const Validator_GeneratedProps = {
// 
};
export const DBDef_EHRInstanceKBVersion = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: EhrInstanceKbVersion_CollectionName,
    entityName: 'EHRInstanceKBVersion',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: EhrInstanceKbVersion_CollectionName
    },
    backend: {
        name: EhrInstanceKbVersion_CollectionName
    },
};
//# sourceMappingURL=db-def.js.map